const OfferListModalLangKey = [
	'title_bind',
	'title_unbind',
	'title_unscoped',
	'title_unscoped_in_group',
	'title_view',
	'btn_close'
] as const

type IOfferListModalLangKey = typeof OfferListModalLangKey[number]

export type IOfferListModalLang = {
	offer_list_modal: Record<IOfferListModalLangKey, string>
}

const langEntries = OfferListModalLangKey.map(
	(key: IOfferListModalLangKey) => [key, `offer_list_modal.${key}`]
)

const langObj: Record<IOfferListModalLangKey, string> = Object.fromEntries(langEntries)

export const OFFER_LIST_MODAL_LANG_KEY: IOfferListModalLang = {
	offer_list_modal: langObj
}